import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config } from "../../shared";

// https://api.akaun.cloud/core2/tnt/dm/wf/md/process-status/available-process-statuses/backoffice-ep?

@Injectable({ providedIn: "root" })
export class WfMdAvailableStatusService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX;
    this.httpClient = http;
  }
  getStatus(
        processHdr: any,
        currentStatus: any,
        visa: ApiVisa
      ): Observable<BasicApiResponseModel<any>> {
      
        this.apiUrl = visa.api_domain_url + this.endpoint_path + "md/process-status/available-process-statuses/backoffice-ep?processHdrGuid=" + processHdr + "&currentStatusGuid="+ currentStatus
      
        return this.httpClient.get<BasicApiResponseModel<any>>(
          this.apiUrl,
          this.getHttpHeader(visa)
       );
     }

   getOrderedStatus(
        processHdr: any,
        currentStatus: any,
        visa: ApiVisa
      ): Observable<BasicApiResponseModel<any>> {
      
        this.apiUrl = visa.api_domain_url + this.endpoint_path + "md/process-status/available-process-statuses-ordered-by-sequence/backoffice-ep?processHdrGuid=" + processHdr + "&currentStatusGuid="+ currentStatus
      
        return this.httpClient.get<BasicApiResponseModel<any>>(
          this.apiUrl,
          this.getHttpHeader(visa)
       );
     }
}
